import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5bbfa032&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=5bbfa032&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bbfa032",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5bbfa032')) {
      api.createRecord('5bbfa032', component.options)
    } else {
      api.reload('5bbfa032', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=5bbfa032&scoped=true", function () {
      api.rerender('5bbfa032', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/riskControl/index.vue"
export default component.exports